




























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getMiddleExam, getMiddleAreaAndSubjects, getAssemblySubjects } from '../../models/api'

@Component
export default class MiddleExam extends Vue {
  private examTypes = []
  private typeValue = null
  private years = []
  private yearValue = null
  private uniform = []
  private uniformValue = null
  private nonuniform = []
  private nonuniformValue = null
  private subjects = []
  private regions_distribute = []
  private showSider = true
  private showAssembly = false
  private assemblyTypes = []
  private assemblyValue = null
  private assemblySubjects = []
  private assemblyRegions = []

  private get userInfo() {
    return this.$store.state.user_info
  }

  public get moduleName() {
    return this.$route.meta.label
  }

  public get paperType(): any {
    return this.examTypes.find((n) => this.typeValue === n[0])
  }

  @Watch('userInfo', { deep: true })
  onUserChange(val, old) {
    this.renderPage()
  }

  mounted() {
    this.renderPage()
  }

  toggleSider() {
    this.showSider = !this.showSider
  }

  goAnchor(selector) {
    console.log(selector)
    var anchor = this.$el.querySelector(selector)
    console.log(anchor.offsetTop)
    document.body.scrollTop = anchor.offsetTop
  }

  public async renderPage() {
    if (!this.userInfo) return
    const arr = Object.keys(this.userInfo)
    if (!(arr && arr.length > 0)) return
    const { data, success }: any = await getMiddleExam({})

    if (success) {
      this.examTypes = data.paper_types_choices
      this.years = data.year_choices
      this.typeValue = this.examTypes[0][0]
      this.yearValue = this.years[0][0]
      this.assemblyTypes = data.assembly_type_choices
      this.assemblyValue = this.assemblyTypes[0][0]
      await this.renderAreaAndSubjects(this.typeValue, this.yearValue)
      await this.renderAssembly(this.assemblyValue)
    }
  }

  public async renderAreaAndSubjects(paper_type, year) {
    const { data, success }: any = await getMiddleAreaAndSubjects({ paper_type, year })

    if (success) {
      this.uniform = data.regions.uniform
      this.nonuniform = data.regions.nonuniform
      this.subjects = data.subjects
      this.regions_distribute = data.regions_distribute
    }
  }

  public async renderAssembly(type) {
    const { data, success }: any = await getAssemblySubjects({ assembly_type: type })

    if (success) {
      this.assemblySubjects = data.subjects
      this.assemblyRegions = data.regions
    }
  }

  public async changeType(type) {
    this.typeValue = type
    this.showAssembly = false
    await this.renderAreaAndSubjects(type, this.yearValue)
  }

  public async changeYear(year) {
    this.yearValue = year
    await this.renderAreaAndSubjects(this.typeValue, year)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '年份',
      value: year,
      paper_type: this.paperType && this.paperType[1]
    })
  }

  public trackAnchor(itm) {
    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '统考地区',
      value: itm[1],
      paper_type: this.paperType && this.paperType[1]
    })
  }

  public trackAnchor2(itm) {
    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '非统考地区',
      value: itm[1],
      paper_type: this.paperType && this.paperType[1]
    })
  }
  public trackAnchor3(city) {
    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '地区导航',
      value: city[1],
      paper_type: this.paperType && this.paperType[1]
    })
  }

  public trackAnchor4(itm) {
    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '科目',
      value: itm[1],
      paper_type: '中考汇编'
    })
  }

  public trackAnchor5(itm) {
    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '科目导航',
      value: itm[1],
      paper_type: '中考汇编'
    })
  }

  public showList(s) {
    const { paper_ids } = s
    const ids = paper_ids.join(',')

    window.open(`/junior/list?is_assembly=0&ids=${ids}`)
  }

  public showAssemblyList(s) {
    const { paper_ids } = s
    const ids = paper_ids.join(',')

    window.open(`/junior/list?is_assembly=1&ids=${ids}`)
  }

  public changeAssembly() {
    this.showAssembly = true
  }

  public async changeAssemblyType(value) {
    this.assemblyValue = value[0]
    await this.renderAssembly(this.assemblyValue)

    window['sensors'].track('TIKU_filter_clk', {
      moduleName: this.moduleName,
      filter: '汇编类型',
      value: value && value[1],
      paper_type: '中考汇编'
    })
  }
}
